import OrderCard from "../components/OrderCard";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function Orders() {
  const [orders, setOrders] = useState([]);
  const tokenBearer = useSelector((state) => state.token);

  const getOrders = async () => {
    const authAxios = axios.create({
      baseURL: `${process.env.REACT_APP_API_URL}/private/orders`,
      headers: {
        Authorization: `Bearer ${tokenBearer.token}`,
        ContentType: `application/json`,
      },
    });
    try {
      const res = await authAxios.get(
        `${process.env.REACT_APP_API_URL}/private/orders`
      );

      setOrders(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getOrders();
  }, []);

  return (
    <div className="container mt-5">
      <div className="row">
        {orders.map((order) => (
          <div className="col-xl-6" key={order._id}>
            <OrderCard
              id={order._id}
              status={order.status}
              date={order.createdAt}
              total={order.total}
              items={order.items}
              buyerId={order.buyerId}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Orders;
